export default __webpack_public_path__ + "static/media/ic-icon-field.eb539c6e.png";